import React, { forwardRef } from 'react';
import cm from 'classnames';
import styles from '../_input.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  value: number;
  className?: string;
  label?: string;
  id: string;
}

const InputRadio = forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
  const { className, label, value, id, ...rest } = props;

  return (
    <div className={cm(styles.InputRadio, className)}>
      <input {...rest} ref={ref} type="radio" id={id} value={value} />
      <label htmlFor={id}>
        <span />
        {label}
      </label>
    </div>
  );
});
InputRadio.displayName = 'InputRadio';

export { InputRadio };
